import { render, staticRenderFns } from "./SimpleProductTable.vue?vue&type=template&id=1789a284&"
import script from "./SimpleProductTable.vue?vue&type=script&lang=js&"
export * from "./SimpleProductTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports